import type { ConversationKind } from "@beacon/core/chat"
import { HashIcon, LockIcon, UserIcon, UsersIcon, type LucideIcon } from "lucide-react"

/*
 * How a conversation shows who reads it wherever it is named by an icon: a private channel by a
 * lock, a public one by a hash, a direct message by a person, a group one by people.
 */

const icons = {
  "public-channel": HashIcon,
  "private-channel": LockIcon,
  dm: UserIcon,
  "group-dm": UsersIcon,
} as const satisfies Record<ConversationKind, LucideIcon>

/** The icon leading a conversation's name. */
export const channelIconOf = (kind: ConversationKind): LucideIcon => icons[kind]

/** What a screen reader hears before a conversation's name, where its icon says it. */
export const privacyOf = (kind: ConversationKind) =>
  ({
    "public-channel": undefined,
    "private-channel": "Private channel",
    dm: "Direct message",
    "group-dm": "Group direct message",
  })[kind]

/** Whether a conversation is a direct message, one-to-one or group, rather than a channel. */
export { isDirect } from "@beacon/core/chat/rules"
